module.exports = __webpack_public_path__ + "img/idea.f18c2b5c.png";